// Angular
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
// Local services
import { AlertService } from '../../../services/alert.service';
import { RoleService } from '../../seguridad-creacion-rol/role.service';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Messages
import { GlobalMessages } from '../../../utils/messages';
import { Messages } from '../messages';

@Component({
  selector: 'role-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  roles = [];
  searchString = '';
  @Output() selecttab = new EventEmitter<any>();

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private loaderService: NgxUiLoaderService,
    private roleService: RoleService,
    private router: Router,
  ) { }

  async ngOnInit() {
    await this.getRoles();
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }

  async getRoles() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.getRoles();
    if (result && result.codigo === 1) {
      this.roles = result.Respuesta;
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    }
  }

  exportAsXLSX(): void {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const data = [];
    this.roles.forEach(role => {
      data.push({
        nombre: role.nombre,
        descripcion: role.descripcion,
        activo: role.activo ? 'ACTIVO' : 'INACTIVO',
      });
    });
    this.loaderService.stopLoader('loader-global', 'loadingDashboard');
  }

  

  async changeRolStatus(role: any) {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.updateRole(role);
    if (result && result.codigo === 1) {
      await this.getRoles();
      await this.alertService.show(
        GlobalMessages.NOTE_TITLE,
        Messages.CHANGE_STATUS_SUCCESS,
      );
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      ).then();
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    }
  }

  editRole(role: any): void {
    role.edit = true;
    this.roleService.setRole(role);
  }

}
